<template>
  <node-view-wrapper class="embed-document">
    <v-card v-if="!node.attrs.documentId" max-width="400px">
      <v-list>
        <!-- Change to subheader -->
        <v-list-item v-if="previousDocumentId">
          <v-btn icon style="cursor: pointer" @click="returnToPrevious"
            ><v-icon>mdi-arrow-left</v-icon></v-btn
          >
        </v-list-item>

        <v-subheader>Select a document</v-subheader>
        <v-text-field
          class="mx-2"
          label="Search"
          prepend-inner-icon="mdi-magnify"
          dense
          v-model="search"
          clearable
          @click:clear="search = ''"
        ></v-text-field>

        <v-list-item-group
          :mandatory="selectedItem === previousDocumentId"
          v-model="selectedItem"
          color="primary"
        >
          <v-list-item
            v-for="(doc, i) in filteredDocumentsList"
            :key="i"
            :value="doc.documentId"
            @click="selectDocument(doc.documentId)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ doc.title }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption grey--text">{{
                doc.path
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>

    <v-hover v-else v-slot="{ hover }">
      <v-card
        class="pa-4"
        style="position: relative"
        :elevation="hover ? 10 : 4"
      >
        <v-card-title v-html="embeddedContent"> </v-card-title>
        <v-btn
          v-if="hover"
          color="yellow darken-4 "
          dark
          top
          left
          small
          absolute
          style="top: -14px"
          class="disable-events"
        >
          {{ titleOfEmbeddedDocument }}
          <span class="text-caption text-lowercase">{{
            pathToEmbeddedDocument
          }}</span>
        </v-btn>

        <v-btn
          @click="close"
          v-if="hover"
          color="red darken-4"
          dark
          absolute
          top
          right
          fab
          small
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn
          @click="setPreviousAndShowSelectDocumentMenuAgain"
          v-if="hover"
          color="yellow darken-4"
          dark
          absolute
          top
          right
          fab
          small
          class="mr-15"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-card>
    </v-hover>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper } from "@tiptap/vue-2";
import { mapGetters } from "vuex";
import store from "@/store";

import axios from "axios";
import GluidTipTapEditorInstance from "@/components/editor/GluidTipTapEditorInstance";

export default {
  data() {
    return {
      selectedItem: 0,
      show: true,
      embeddedContent: null,
      pathToEmbeddedDocument: null,
      titleOfEmbeddedDocument: null,
      hidden: false,
      previousDocumentId: null,
      search: ""
    };
  },
  components: {
    NodeViewWrapper
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    updateAttributes: {
      type: Function,
      required: true
    },
    documentId: null
  },
  computed: {
    ...mapGetters(["activeSpace"]),
    filteredDocumentsList() {
      let items = JSON.parse(JSON.stringify(this.activeSpace.documentIdCache));
      if (!this.search) return items;

      let itemsFiltered = _.pickBy(items, value => {
        return _.includes(_.toLower(value.title), _.toLower(this.search));
      });

      return itemsFiltered;
    }
  },
  mounted() {
    if (this.node.attrs.documentId) {
      this.loadDocument(this.node.attrs.documentId);
    }
  },
  methods: {
    setPreviousAndShowSelectDocumentMenuAgain() {
      this.previousDocumentId = this.node.attrs.documentId;
      this.node.attrs.documentId = null;
    },

    selectDocument(documentId) {
      this.search = "";

      if (documentId) {
        this.updateAttributes({ documentId });
        this.loadDocument(documentId);
      }
    },
    async loadDocument(documentId) {
      const { data } = await axios("/api/document/readDocument", {
        headers: { jwt: store.state.userToken },
        params: { documentId }
      });
      this.selectedItem = documentId;

      this.pathToEmbeddedDocument = this.activeSpace.documentIdCache[
        documentId
      ].path;
      this.titleOfEmbeddedDocument = this.activeSpace.documentIdCache[
        documentId
      ].title;

      const editor = GluidTipTapEditorInstance(false, false);
      editor.commands.setContent(data);
      this.embeddedContent = editor.getHTML();
    },
    close() {
      this.$el.parentNode.removeChild(this.$el);
    },
    returnToPrevious() {
      this.node.attrs.documentId = this.previousDocumentId;
    }
  }
};
</script>
<style scoped>
.v-tooltip__content {
  pointer-events: initial;
}
.disable-events {
  pointer-events: none;
}
</style>
